/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.updateCartDiscount = function(discount, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: {
      discount: attributeToString(discount)
    },
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };

  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body, tierDiscountConfig, isSyncingTierDiscount, lastAppliedTierDiscountCode;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty, initTierDiscountConfig, parseTierDiscountMap, getCookieByName, hasTierDiscountAccess, isSubscriptionCartItem, getTierEligibility, getTierDiscountCode, normalizeDiscountCode, cartHasDiscountCode, cartHasAnyTierDiscountCode, syncTierDiscount, getTierDiscountLabel, getTierProgressLabel, getTierProgressMessage, getTierProgressIconClass, formatTierAmountForMessage, getTierProgressData;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);
    $drawerContainer   = $('#CartDrawer');

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;
    isSyncingTierDiscount = false;
    lastAppliedTierDiscountCode = null;

    initTierDiscountConfig();

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  initTierDiscountConfig = function() {
    var tiersData;
    var parsedTiers;
    var isEnabled;
    var i;
    var minimum;
    var code;
    var label;
    var type;
    var secureEnabled;
    var secureCookieName;
    var secureCookieValue;

    tierDiscountConfig = {
      enabled: false,
      hasAccess: true,
      isActive: false,
      tiers: [],
      secure: {
        enabled: false,
        cookieName: '',
        cookieValue: ''
      }
    };

    if (!$drawerContainer.length) {
      return;
    }

    tiersData = attributeToString($drawerContainer.attr('data-tier-discount-map'));
    isEnabled = $drawerContainer.data('tierDiscountEnabled');
    secureEnabled = $drawerContainer.data('tierDiscountSecureEnabled');
    secureCookieName = attributeToString($drawerContainer.data('tierDiscountSecureCookieName'));
    secureCookieValue = attributeToString($drawerContainer.data('tierDiscountSecureCookieValue'));

    if (!tiersData) {
      return;
    }

    parsedTiers = parseTierDiscountMap(tiersData);

    for (i = 0; i < parsedTiers.length; i++) {
      minimum = parseInt(parsedTiers[i].minimum, 10);
      code = attributeToString(parsedTiers[i].code);
      label = attributeToString(parsedTiers[i].label);
      type = attributeToString(parsedTiers[i].type).toLowerCase();

      if (type !== 'free_shipping') {
        type = 'discount';
      }

      if (!isNaN(minimum) && (type === 'free_shipping' || code !== '')) {
        tierDiscountConfig.tiers.push({
          minimum: minimum,
          code: code,
          label: label,
          type: type
        });
      }
    }

    tierDiscountConfig.tiers.sort(function(a, b) {
      return a.minimum - b.minimum;
    });

    tierDiscountConfig.enabled = tierDiscountConfig.tiers.length > 0 && (isEnabled === true || isEnabled === 'true');
    tierDiscountConfig.secure.enabled = secureEnabled === true || secureEnabled === 'true';
    tierDiscountConfig.secure.cookieName = secureCookieName;
    tierDiscountConfig.secure.cookieValue = secureCookieValue;
    tierDiscountConfig.hasAccess = hasTierDiscountAccess();
    tierDiscountConfig.isActive = tierDiscountConfig.enabled && tierDiscountConfig.hasAccess;
  };

  parseTierDiscountMap = function(tiersData) {
    var parsedTiers = [];
    var jsonTiers;
    var lines;
    var i;
    var line;
    var parts;

    if (!tiersData) {
      return parsedTiers;
    }

    try {
      jsonTiers = JSON.parse(tiersData);

      if ($.isArray(jsonTiers)) {
        return jsonTiers;
      }
    } catch (e) {}

    lines = tiersData.split(/\r?\n/);

    for (i = 0; i < lines.length; i++) {
      line = attributeToString(lines[i]);

      if (!line || line.charAt(0) === '#') {
        continue;
      }

      parts = line.split('|');

      if (parts[0] === 'discount' || parts[0] === 'free_shipping' || parts[0] === 'shipping') {
        if ((parts[0] === 'free_shipping' || parts[0] === 'shipping') && parts.length === 3) {
          parsedTiers.push({
            type: 'free_shipping',
            minimum: parts[1],
            code: '',
            label: parts[2]
          });

          continue;
        }

        parsedTiers.push({
          type: parts[0] === 'shipping' ? 'free_shipping' : parts[0],
          minimum: parts[1],
          code: parts[2],
          label: parts.slice(3).join('|')
        });
      } else {
        parsedTiers.push({
          type: 'discount',
          minimum: parts[0],
          code: parts[1],
          label: parts.slice(2).join('|')
        });
      }
    }

    return parsedTiers;
  };

  getCookieByName = function(cookieName) {
    var allCookies;
    var i;
    var cookie;
    var separatorIndex;
    var name;
    var value;

    if (!cookieName || !document.cookie) {
      return null;
    }

    allCookies = document.cookie.split(';');

    for (i = 0; i < allCookies.length; i++) {
      cookie = jQuery.trim(allCookies[i]);
      separatorIndex = cookie.indexOf('=');

      if (separatorIndex === -1) {
        continue;
      }

      name = decodeURIComponent(cookie.substring(0, separatorIndex));
      value = decodeURIComponent(cookie.substring(separatorIndex + 1));

      if (name === cookieName) {
        return value;
      }
    }

    return null;
  };

  hasTierDiscountAccess = function() {
    var expectedValue;
    var cookieValue;

    if (!tierDiscountConfig.secure.enabled) {
      return true;
    }

    if (!tierDiscountConfig.secure.cookieName) {
      return false;
    }

    cookieValue = attributeToString(getCookieByName(tierDiscountConfig.secure.cookieName));
    expectedValue = attributeToString(tierDiscountConfig.secure.cookieValue);

    if (!cookieValue) {
      return false;
    }

    if (!expectedValue) {
      return true;
    }

    return cookieValue === expectedValue;
  };

  isSubscriptionCartItem = function(cartItem) {
    var properties;
    var key;

    if (!cartItem) {
      return false;
    }

    if (cartItem.selling_plan_allocation || cartItem.selling_plan) {
      return true;
    }

    properties = cartItem.properties;

    if (!properties || typeof properties !== 'object') {
      return false;
    }

    if (properties.subscription_id) {
      return true;
    }

    for (key in properties) {
      if (!Object.prototype.hasOwnProperty.call(properties, key)) {
        continue;
      }

      if (key === 'subscription_id' || key === '_subscription_id') {
        return true;
      }
    }

    return false;
  };

  getTierEligibility = function(cart) {
    var eligibility = {
      subtotal: 0,
      hasEligibleItems: false
    };
    var linePrice;

    if (!cart || !cart.items || !cart.items.length) {
      return eligibility;
    }

    jQuery.each(cart.items, function(index, cartItem) {
      if (isSubscriptionCartItem(cartItem)) {
        return;
      }

      eligibility.hasEligibleItems = true;
      linePrice = parseInt(cartItem.original_line_price, 10);

      if (!isNaN(linePrice)) {
        eligibility.subtotal += linePrice;
      }
    });

    return eligibility;
  };

  getTierDiscountCode = function(subtotalPrice) {
    var subtotal = parseInt(subtotalPrice, 10);
    var matchedCode = '';
    var i;

    if (isNaN(subtotal)) {
      subtotal = 0;
    }

    for (i = 0; i < tierDiscountConfig.tiers.length; i++) {
      if (tierDiscountConfig.tiers[i].type === 'discount' && subtotal >= tierDiscountConfig.tiers[i].minimum) {
        matchedCode = tierDiscountConfig.tiers[i].code;
      }
    }

    return matchedCode;
  };

  getTierDiscountLabel = function(tier) {
    var parsedCode;

    if (!tier) {
      return '';
    }

    if (attributeToString(tier.label) !== '') {
      return attributeToString(tier.label);
    }

    parsedCode = normalizeDiscountCode(tier.code).match(/(\d+)\s*OFF/);

    if (parsedCode && parsedCode[1]) {
      return parsedCode[1] + '% OFF';
    }

    return tier.code;
  };

  getTierProgressLabel = function(tier) {
    var label = getTierDiscountLabel(tier);

    if (!tier || tier.type !== 'free_shipping') {
      return label;
    }

    return label || '';
  };

  getTierProgressMessage = function(tier, remainingAmount) {
    var label = getTierProgressLabel(tier);

    if (!tier) {
      return '';
    }

    if (remainingAmount > 0) {
      if (tier.type === 'free_shipping') {
        return 'Add ' + formatTierAmountForMessage(remainingAmount) + ' in one-time items to get ' + label.toLowerCase();
      }

      return 'Add ' + formatTierAmountForMessage(remainingAmount) + ' in one-time items to get a discount ' + label;
    }

    if (tier.type === 'free_shipping') {
      return 'You unlocked ' + label.toLowerCase();
    }

    return 'You unlocked the highest one-time discount ' + label;
  };

  getTierProgressIconClass = function(tier) {
    if (tier && tier.type === 'free_shipping') {
      return 'fa fa-truck';
    }

    return 'fa fa-tag';
  };

  formatTierAmountForMessage = function(amountInCents) {
    return Shopify.formatMoney(amountInCents, settings.moneyFormat).replace(/\.00(?=\D*$)/, '');
  };

  getTierProgressData = function(subtotalPrice, hasEligibleItems) {
    var subtotal = parseInt(subtotalPrice, 10);
    var tiers = tierDiscountConfig.tiers;
    var lastMinimum;
    var progressStart;
    var progressEnd;
    var range;
    var nextTier = null;
    var progressWidth = 0;
    var tierItems = [];
    var i;
    var position;
    var remainingAmount;
    var message;

    tierDiscountConfig.hasAccess = hasTierDiscountAccess();
    tierDiscountConfig.isActive = tierDiscountConfig.enabled && tierDiscountConfig.hasAccess;

    if (!tierDiscountConfig.isActive || !tiers.length || !hasEligibleItems) {
      return null;
    }

    if (isNaN(subtotal)) {
      subtotal = 0;
    }

    lastMinimum = tiers[tiers.length - 1].minimum;
    progressStart = 0;
    progressEnd = lastMinimum;
    range = progressEnd - progressStart;

    if (range <= 0) {
      progressWidth = subtotal >= progressEnd ? 100 : 0;
    } else {
      progressWidth = ((subtotal - progressStart) / range) * 100;
    }

    progressWidth = Math.max(0, Math.min(100, progressWidth));

    for (i = 0; i < tiers.length; i++) {
      if (!nextTier && subtotal < tiers[i].minimum) {
        nextTier = tiers[i];
      }

      if (range <= 0) {
        position = 100;
      } else {
        position = ((tiers[i].minimum - progressStart) / range) * 100;
      }

      position = Math.max(0, Math.min(100, position));

      tierItems.push({
        minimum: tiers[i].minimum,
        code: tiers[i].code,
        label: getTierProgressLabel(tiers[i]),
        iconClass: getTierProgressIconClass(tiers[i]),
        achieved: subtotal >= tiers[i].minimum,
        position: position
      });
    }

    if (nextTier) {
      remainingAmount = nextTier.minimum - subtotal;
      message = getTierProgressMessage(nextTier, remainingAmount);
    } else {
      message = getTierProgressMessage(tiers[tiers.length - 1], 0);
    }

    return {
      message: message,
      progressWidth: progressWidth,
      tiers: tierItems
    };
  };

  normalizeDiscountCode = function(code) {
    return attributeToString(code).toUpperCase();
  };

  cartHasDiscountCode = function(cart, discountCode) {
    var targetCode = normalizeDiscountCode(discountCode);

    if (!targetCode || !cart || !cart.cart_level_discount_applications || !cart.cart_level_discount_applications.length) {
      return false;
    }

    for (var i = 0; i < cart.cart_level_discount_applications.length; i++) {
      if (normalizeDiscountCode(cart.cart_level_discount_applications[i].title) === targetCode) {
        return true;
      }
    }

    return false;
  };

  cartHasAnyTierDiscountCode = function(cart) {
    var i;
    var j;
    var appliedCode;

    if (!cart || !cart.cart_level_discount_applications || !cart.cart_level_discount_applications.length) {
      return false;
    }

    for (i = 0; i < cart.cart_level_discount_applications.length; i++) {
      appliedCode = normalizeDiscountCode(cart.cart_level_discount_applications[i].title);

      for (j = 0; j < tierDiscountConfig.tiers.length; j++) {
        if (
          tierDiscountConfig.tiers[j].type === 'discount' &&
          appliedCode === normalizeDiscountCode(tierDiscountConfig.tiers[j].code)
        ) {
          return true;
        }
      }
    }

    return false;
  };

  syncTierDiscount = function(cart, callback) {
    var desiredCode;
    var tierEligibility;
    var clearTierDiscount;
    var complete = function(nextCart) {
      if ((typeof callback) === 'function') {
        callback(nextCart || cart);
      }
    };

    clearTierDiscount = function() {
      isSyncingTierDiscount = true;

      ShopifyAPI.updateCartDiscount('', function(updatedCart) {
        isSyncingTierDiscount = false;
        lastAppliedTierDiscountCode = null;
        complete(updatedCart);
      }, function() {
        isSyncingTierDiscount = false;
        lastAppliedTierDiscountCode = null;
        complete(cart);
      });
    };

    if (isSyncingTierDiscount) {
      complete(cart);
      return;
    }

    if (!tierDiscountConfig.enabled) {
      if (cartHasAnyTierDiscountCode(cart)) {
        clearTierDiscount();
      } else {
        complete(cart);
      }
      return;
    }

    tierDiscountConfig.hasAccess = hasTierDiscountAccess();
    tierDiscountConfig.isActive = tierDiscountConfig.enabled && tierDiscountConfig.hasAccess;
    tierEligibility = getTierEligibility(cart);

    if (!tierDiscountConfig.hasAccess) {
      if (cartHasAnyTierDiscountCode(cart)) {
        clearTierDiscount();
      } else {
        complete(cart);
      }
      return;
    }

    if (!tierEligibility.hasEligibleItems) {
      if (cartHasAnyTierDiscountCode(cart)) {
        clearTierDiscount();
      } else {
        complete(cart);
      }
      return;
    }

    desiredCode = getTierDiscountCode(tierEligibility.subtotal);

    if (!desiredCode) {
      if (cartHasAnyTierDiscountCode(cart)) {
        clearTierDiscount();
      } else {
        complete(cart);
      }
      return;
    }

    if (
      normalizeDiscountCode(lastAppliedTierDiscountCode) === normalizeDiscountCode(desiredCode) ||
      cartHasDiscountCode(cart, desiredCode)
    ) {
      lastAppliedTierDiscountCode = desiredCode;
      complete(cart);
      return;
    }

    isSyncingTierDiscount = true;

    ShopifyAPI.updateCartDiscount(desiredCode, function(updatedCart) {
      isSyncingTierDiscount = false;
      lastAppliedTierDiscountCode = desiredCode;
      complete(updatedCart);
    }, function() {
      isSyncingTierDiscount = false;
      lastAppliedTierDiscountCode = null;
      complete(cart);
    });
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback.bind(this));
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var $form = $(this);
    var $button = $form.find(settings.addToCartSelector);
    var data = eval('(' + XMLHttpRequest.responseText + ')');

    $button.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $form.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    syncTierDiscount(cart, buildCart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<p>' + "Your cart is currently empty." + '</p>');
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        has_subs = false,
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }
      var isKiteFreeGift = false;
      if (cartItem.properties !== null) {
        if (cartItem.properties._free_product || cartItem.properties._free_product_checkout) {
          isKiteFreeGift = true;
        }
        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
          if ( key === 'subscription_id' ) {
            has_subs = true;
          }
        });
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
        });
      }

      if (cartItem.line_level_discount_allocations.length !== 0) {
        for (var discount in cartItem.line_level_discount_allocations) {
          var amount =
            cartItem.line_level_discount_allocations[discount].amount;

          cartItem.line_level_discount_allocations[
            discount
          ].formattedAmount = Shopify.formatMoney(
            amount,
            settings.moneyFormat
          );
        }
      }

      if (cart.cart_level_discount_applications.length !== 0) {
        for (var cartDiscount in cart.cart_level_discount_applications) {
          var cartAmount =
            cart.cart_level_discount_applications[cartDiscount]
              .total_allocated_amount;

          cart.cart_level_discount_applications[
            cartDiscount
          ].formattedAmount = Shopify.formatMoney(
            cartAmount,
            settings.moneyFormat
          );
        }
      }

      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.variant_id,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        isKiteFreeGift: isKiteFreeGift,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(
          cartItem.original_line_price,
          settings.moneyFormat
        ),
        discountedPrice: Shopify.formatMoney(
          cartItem.final_line_price,
          settings.moneyFormat
        ),
        discounts: cartItem.line_level_discount_allocations,
        discountsApplied:
          cartItem.line_level_discount_allocations.length === 0 ? false : true,
        vendor: cartItem.vendor
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    var tierEligibility = getTierEligibility(cart);
    var tierProgress = getTierProgressData(tierEligibility.subtotal, tierEligibility.hasEligibleItems);

    data = {
      items: items,
      has_subs: has_subs,
      note: cart.note,
      subTotalPrice: Shopify.formatMoney(
        cart.items_subtotal_price,
        settings.moneyFormat
      ),
      totalPrice: Shopify.formatMoney(
        cart.total_price,
        settings.moneyFormat
      ),
      cartTotalDiscounts: Shopify.formatMoney(
        cart.total_discount,
        settings.moneyFormat
      ),
      cartDiscounts: cart.cart_level_discount_applications,
      cartDiscountsApplied:
        cart.cart_level_discount_applications.length === 0 ? false : true,
      cartTotalSavings: cart.cart_level_discount_applications.length === 0 && cart.total_discount > 0,
      tierProgressEnabled: tierProgress !== null,
      tierProgress: tierProgress
    };

    $cartContainer.append(template(data));

    cartCallback(cart);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('ajaxCart.afterCartLoad', cart);
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    isUpdating = false;

    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      ShopifyAPI.getCart(cartUpdateCallback);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty,
            isKiteFreeGift = $el.closest('.cart-item').hasClass('cart-item--free-gift');

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId,
              isKiteFreeGift: isKiteFreeGift
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };



  return module;

}(ajaxCart || {}, jQuery));
